import React from 'react'
import PropTypes from 'prop-types'
import Product from './product'
import './products-list.scss'

class ProductsList extends React.Component {
  render() {
    return (
      <div className="product-list">
        <h2 className="product-list__title">{this.props.title}</h2>
        {this.props.products.map((product, i) => (
          <Product product={product} key={i} />
        ))}
      </div>
    )
  }
}

ProductsList.propTypes = {
  title: PropTypes.string.isRequired,
  dataReview: PropTypes.object
};

export default ProductsList



// WEBPACK FOOTER //
// ./src/components/products-list/products-list.js